import reducer from './reducer'

import * as facilityTypesOperations from './operations'
import * as facilityTypesSelectors from './selectors'

export { facilityTypesOperations, facilityTypesSelectors }

export default reducer
